import { createFileRoute } from '@tanstack/react-router';
import { ApplyForAccountForm } from '@/components/ApplyForAccountForm.tsx';
import { CenteredColumn } from '@/components/CenteredColumn';
import { useConfig } from '@/contexts/ConfigContext';
import { cn } from '@/helpers/classnames';
import { useTenantID } from '@/hooks/useTenantID';
import { DocumentHead } from '@/components/core/DocumentHead';
import { useFavicon } from '@/hooks/useFavicon';

export const Route = createFileRoute('/$tenantId/register')({
  component: Register,
});

function Register() {
  const { disabled } = useConfig();
  const tenantId = useTenantID();
  useFavicon(tenantId);

  if (disabled) {
    return null;
  }

  return (
    <>
      <DocumentHead
        titleKey="page.register.title"
        descriptionKey="page.register.description"
      />
      <CenteredColumn className={cn('h-fit', tenantId)}>
        <ApplyForAccountForm />
      </CenteredColumn>
    </>
  );
}
